<template>
	<div class="custer-cascader">
		<!-- <p class="tips">进行拖拽之前请选中当前要拖拽的行</p> -->
		<el-cascader-panel :options="lists" :props="props"  @active-item-change="handleItemChange" ref="cascaderAddr" :key="cascaderKey">
			<template slot-scope="{ node, data }">
			    <div class="content">
					<span class="label" v-if="!data.isEdit">{{ data.label }}</span>
					<el-input v-model="val" v-else placeholder="请输入..." style="width: 100px;" @blur="blurEvent"></el-input>
					<span>
						<el-popover
						  placement="top"
						  trigger="click"
						  width="160">
						  <p>添加同级还是子级</p>
						  <div style="text-align: right; margin: 0">
						    <el-button size="mini" type="text" @click.stop="onAdd(node,data,'same')">同级</el-button>
						    <el-button type="text" size="mini" @click.stop="onAdd(node,data,'diff')">子级</el-button>
						  </div>
						 <i slot="reference" class="el-icon-circle-plus-outline"></i>
						</el-popover>
						<i class="el-icon-edit" @click.stop="onEdit(node,data)"></i>
						<i class="el-icon-delete" @click.stop="onDelete(node,data)" v-show="lists.length > 1"></i>
						<span class="my-mover" v-if="checked.includes(data.value)"><svg-icon icon-class="move"></svg-icon></span>
					</span>
				</div>
			</template>
		</el-cascader-panel>
	</div>
</template>

<script>
	export default {
		props:['optionsLists'],
		data(){
			return {
				// options:[{
				// 	 value: '0',
				// 	 label: '默认',
				// 	 isEdit:false,
				// 	 children:[]
				// }],
			    props: { 
				  expandTrigger: 'click'
				},
				lists:[],
				checked:[],
				val:'',
				currentRow:'',
				indexArr:[], //当前要操作得索引数组
				cascaderKey:0
			}
		},
		watch:{
			'optionsLists':{
				handler(val){
					this.lists = this.formatData(val,'show');
					this.$nextTick(() => {
						this.initDrag()
					})
				},
				deep:true,
				immediate:true
			},
			'lists':{
				handler(val){
					let result = this.formatData(val,'submit');
					this.$emit("optionsJson",result)
				},
				deep:true
			}
		},
		methods: {
			// 添加数据
			onAdd(node,data,type){
				if(type == 'diff') {
					data.children.push({
						value: this.uniqueNumber(),
						label: '默认子级',
						isEdit:false,
						children:[]
					})
				}else {
					if(node.level == 1) {
						this.lists.push({
							value: this.uniqueNumber(),
							label: '默认',
							isEdit:false,
							children:[]
						})
					}else {
						// this.indexArr = [];
						// let allIndex = this.getChildrenMenus(this.options);
						this.setValue(this.lists,node.parent.value)
					}
					
					
					
				}
				this.$forceUpdate()
			},
			// 设置同级添加方法递归
			setValue(data,id){
				for (var i in data) {
					if (data[i].value == id) {
						data[i].children.push({
							value:this.uniqueNumber(),
							label:'默认子级' + i,
							isEdit:false,
							children:[]
						})
						break
					}
					if (data[i].children) {
						this.setValue(data[i].children, id);
					}
				}
			},
			// 获取当前元素索引
			getChildrenMenus(children,node) {
				 for (var i = 0; i < children.length; i++) {
					   for(let j in this.checked) {
						   if(children[i].value == this.checked[j]) {
								this.indexArr.push(i);
						   }
					   }
			        if (typeof children[i].children != "undefined") {
						this.getChildrenMenus(children[i].children);
			        }
					
			      }
				  return this.indexArr
			},
			// 格式化级联数据为了展示
			formatData(children,type){
				let itemArr = [];
				for (var i = 0; i < children.length; i++) {
					let item = {};
						item.value = children[i].value;
						item.label = children[i].label;
						if( type== 'show'){
							item.isEdit = false;
						}
					if (typeof children[i].children != "undefined") {
						 item.children = this.formatData(children[i].children,type);
					}
					itemArr.push(item);
			  }
			  return itemArr;
			},
			// 生成唯一id
			uniqueNumber(){
				 return Math.random().toString(36).substr(2)
			},
			handleItemChange(val){
				this.checked = val;
				this.$nextTick(() => {
					this.initDrag()
				})
			},
			// 编辑
			onEdit(node,data){
				this.val = data.label;
				this.currentRow = data;
				data.isEdit = true
			},
			deleteValue(data,pid,id){
				for (var i in data) {
					if (data[i].value == pid) {
						const key = data[i].children.findIndex((el) => el.value == id);
						data[i].children.splice(key,1);
						// this.cascaderKey++;//动态渲染下级联 防止警告
						break
					}
					if (data[i].children) {
						this.deleteValue(data[i].children, pid, id);
					}
				}
			},
			// 删除
			onDelete(node,data){
				if(node.level == 1) {
					let index = this.lists.findIndex((el) => el.value == data.value);
					this.lists.splice(index,1)
				}else {
					this.deleteValue(this.lists,node.parent.value,data.value)
				}
			},
			blurEvent(){
				if(!this.val){
					this.$message.error('请输入...');
					return
				}
				this.currentRow.isEdit = false;
				this.currentRow.label = this.val;
				this.val = ''
				
			},
			dragValue(data,newIndex,oldIndex){
				for (var i in data) {
					if (data[i].value == this.checked[this.checked.length - 2]) {
						const currRow = data[i].children.splice(oldIndex, 1)[0];
						data[i].children.splice(newIndex, 0, currRow);
						break
					}
					if (data[i].children) {
						this.dragValue(data[i].children,newIndex,oldIndex);
					}
				}
			},
			initDrag(){
				let that= this;
				const tbody = this.$refs.cascaderAddr.$el.querySelectorAll('.el-cascader-menu__list') // table
				for (var i = 0; i < tbody.length; i++) { 
					Sortable.create(tbody[i],{
						sort: true,
						animation: 150,
						handle:'.my-mover',
						onEnd:(evt) => {
						   if(i == 1) {
								const currRow = this.lists.splice(evt.oldIndex, 1)[0];
								this.lists.splice(evt.newIndex, 0, currRow);
							}else {
								this.dragValue(this.lists,evt.newIndex,evt.oldIndex)
							}
						}
				   })
				} 
				 
			}
		},
	}
</script>

<style lang="scss">
	.custer-cascader {
		margin-top: 20px;
		max-width: 100%;
		
		span {
			font-size: 12px;
		}
		.tips {
			margin-bottom: 10px;
			font-size: 14px;
			color: #FF504D;
		}
		.content {
			display: flex;
		}
		.el-cascader-panel {
			max-width: 100%;
			overflow-x: auto;
		}
		.label{
			margin-right: 5px;
			max-width: 100px;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			display: inline-block;
		}
		i {
			margin-right: 3px;
		}
		.my-mover {
			font-size: 14px;
		}
	}
</style>
